import './i18n.config';
import ReactDOM from 'react-dom';
import './index.scss';
import './inline.css';
import Biobar from 'biobar';
import CustomConfig from 'models/CustomConfig';
import includeCSS from 'setup/includeCSS';
import includeBiobarDiv from 'setup/includeBiobarDiv';
import { setupDevelopment } from 'index-development';
import { isDevelopment } from 'utils/constants';

if(isDevelopment())
  RenderBiobar(setupDevelopment());

function SetupBiobar(props : CustomConfig) : void {
  includeCSS();
  includeBiobarDiv(props.ignoreDefaultBiobarDiv);
  RenderBiobar(props);
}

function RenderBiobar(props : CustomConfig) : void  {
  ReactDOM.render(
    <Biobar {...props} />,
    document.getElementById(props.render || 'biobar')
  );
}

// eslint-disable-next-line
// @ts-ignore
window.Biobar = SetupBiobar;
export { SetupBiobar as default };
